module.exports = __webpack_public_path__ + "img/cg_e.312af9a4.png";